module.exports = __webpack_public_path__ + "static/point_no_Data.9fd14838.png";